import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

interface IProps {
    dialogOpen: boolean;
    handleClose: () => void;
    runTripRate: (selectedIndex: number) => void;
    params: string[];
}

export default function TripRateParametersDialog({ dialogOpen, handleClose, runTripRate, params }: IProps) {
    return (
        <Dialog open={dialogOpen} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle>Select Trip Rate Parameter</DialogTitle>
            <DialogContent>
                <List>
                    {params.map((param, index) =>
                        param.trim() !== "" && (
                            <ListItemButton
                                key={index}
                                onClick={() => runTripRate(index)}
                            >
                                <ListItemText primary={param} />
                            </ListItemButton>
                        )
                    )}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}
